import React, { Suspense, useState } from 'react';
import { forTemplate } from '@trello/i18n';
import { useRecentlyUsedFeaturePreloader } from '@trello/recently-used-feature-preloader';
import { RecentlyViewedBoardsMenuTestIds } from '@trello/test-ids';
import { HeaderMenu } from 'app/src/components/HeaderMenu';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { useRecentBoards } from './useRecentBoards';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';

const format = forTemplate('recently_viewed_boards_menu');

const ErrorComponent: React.FC = () => (
  <p>{format('error-loading-recent-boards')}</p>
);

export const RecentlyViewedBoardsMenuButton: React.FunctionComponent = () => {
  const [skipPreload, setSkipPreload] = useState(true);
  useRecentBoards({ skip: skipPreload });

  const [
    RecentlyViewedBoardsMenuPopover,
    trackFeatureUsage,
  ] = useRecentlyUsedFeaturePreloader({
    featureName: 'RecentlyViewedBoardsMenuPopover',
    useLazyComponentArgs: [
      () =>
        import(
          /* webpackChunkName: "recently-viewed-boards-menu-popover" */ './RecentlyViewedBoardsMenuPopover'
        ),
      { namedImport: 'RecentlyViewedBoardsMenuPopover' },
    ],
    onPreloadedCallback: () => setSkipPreload(false),
  });

  return (
    <HeaderMenu
      buttonText={format('recent')}
      analyticsButtonName="recentlyViewedButton"
      analyticsComponentName="recentlyViewedBoardsMenuInlineDialog"
      popoverTitle={format('recent-boards')}
      dataTestId={RecentlyViewedBoardsMenuTestIds.RecentlyViewedBoardsMenu}
      onClick={trackFeatureUsage}
    >
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-teamplates',
          feature: 'Recently Viewed Boards Menu',
        }}
        errorHandlerComponent={ErrorComponent}
      >
        <Suspense fallback={null}>
          <ChunkLoadErrorBoundary fallback={ErrorComponent}>
            <RecentlyViewedBoardsMenuPopover />
          </ChunkLoadErrorBoundary>
        </Suspense>
      </ErrorBoundary>
    </HeaderMenu>
  );
};
